import React from 'react'
import SbEditable from 'storyblok-react'
import Wave from 'src/utils/Wave'
import FluidImage from 'src/utils/FluidImage'
import Heading from 'src/components/Heading'
import Cloud from 'src/images/cloud.svg'
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs'
import Button from 'src/components/Button'
import Form from 'src/components/Form'
import RichText from 'src/utils/RichText'

const HeroSlimline = ({ blok, page }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        className={`${blok?.CardBlok?.length > 0 ? 'max-w-6xl mx-auto' : ''}`}
      >
        <div
          className={`relative ${
            blok.lightblue_background ? '' : 'bg-brightgreen'
          }`}
        >
          <div
            className={`relative max-w-6xl mx-auto py-11 px-6   ${
              blok.paddingTop ? `pt-${blok.paddingTop}` : ''
            } ${blok.paddingBottom ? `pb-${blok.paddingBottom}` : 'pb-16'} `}
          >
            <div
              className={`flex justify-center items-start ${
                blok.image?.filename
                  ? 'lg:flex-row flex-col gap-12 items-center'
                  : 'flex-col'
              }`}
            >
              <div
                className={`${
                  blok.image?.filename
                    ? 'lg:w-7/12 w-full lg:pt-24'
                    : 'w-full text-center mx-auto'
                }`}
              >
                {!blok?.enableLabel ? (
                  <CustomBreadcrumbs
                    white={blok.lightblue_background ? false : true}
                    className="lg:mb-14 md:mb-12 mb-8"
                    page={page}
                  />
                ) : (
                  <p className="tracking-wider text-darkblue text-sm font-semibold mb-8">
                    {blok.Lable}
                  </p>
                )}

                <div
                  className={`prose text-darkblue !text-[40px] !leading-[44px] lg:!text-[48px] lg:!leading-[53px] font-bold not-prose ${
                    blok.image?.filename ? '' : 'max-w-[800px] mx-auto'
                  }`}
                >
                  <RichText>{blok.title}</RichText>
                </div>
                <p className="mt-10 font-display font-semibold text-xl text-darkblue">
                  {blok.SubHeading}
                </p>
                <p
                  className={`prose font-display mt-6 font-light text-sm tracking-wider leading-snug not-prose  ${
                    blok.image?.filename ? 'max-w-4xl' : ''
                  } ${
                    blok.lightblue_background
                      ? 'text-darkblue'
                      : 'text-darkblue'
                  }`}
                >
                  <RichText>{blok.description}</RichText>
                  {/* {blok.description} */}
                </p>
                <Button
                  to={blok.button_target?.cached_url}
                  className="bg-darkblue !rounded-full hover before:content-[attr(before)] mt-6 py-4 px-7 "
                  before={blok.button_text}
                >
                  {blok.button_text}
                </Button>
              </div>
              <div className={`relative md:w-5/12 w-full p-[0.5px]`}>
                {blok?.toggleImageOrForm === 'image' ? (
                  <FluidImage
                    className="object-cover object-center md:max-w-[500px] mx-auto"
                    image={blok.image}
                    style={{ height: '100px', width: '100px' }}
                  />
                ) : blok.toggleImageOrForm === 'form' ? (
                  <div className={`${page === 'OrphanPage' ? 'mt-32' : ''}`}>
                    <img
                      src={blok?.form[0]?.image[0]?.filename}
                      style={{
                        height: 'auto',
                        width: '100%',
                      }}
                    />
                    <div
                      className="relative max-w-xl mx-auto 2xl:max-w-screen-2xl p-4 bg-white"
                      style={{ boxShadow: '0 0 3px #000000' }}
                    >
                      <div className="text-center 2xl:max-w-3xl mx-auto mt-4">
                        <Heading
                          size="h4"
                          className="text-darkblue mb-8 brightgreenBold"
                        >
                          <RichText>{blok?.form[0].title}</RichText>
                        </Heading>
                        <div className="prose md:text-base text-sm text-darkblue-500">
                          <RichText>{blok?.form[0].description}</RichText>
                        </div>
                      </div>
                      <div className="mt-5 2xl:max-w-3xl mx-auto">
                        {blok?.form && <Form blok={blok?.form[0]} />}
                      </div>
                    </div>
                  </div>
                ) : null}

                {!blok.hide_cloud && (
                  <Cloud
                    className={`absolute z-20 top-0 left-0 w-full h-full ${
                      blok.lightblue_background ? '' : 'fill-brightgreen'
                    }`}
                  />
                )}
              </div>
            </div>
            {blok?.CardBlok?.length > 0 && (
              <div className="lg:max-w-[1004px] md:max-w-[761px] min-h-[455px]  px-1 py-[40px] grid lg:grid-cols-3 gap-[17px] mx-auto">
                {blok.CardBlok.map(item => (
                  <div
                    key={item}
                    className="bg-white  shadow-md p-6 rounded-lg flex flex-col items-start text-start border"
                  >
                    {item.image.filename && (
                      <img
                        src={item.image.filename}
                        alt={item.image.title}
                        className="w-16 h-16 mb-6"
                      />
                    )}
                    <h2 className="text-2xl font-semibold font-display pb-4">
                      {item.title}
                    </h2>
                    <p className="text-gray-600 text-base font-normal font-display pb-8">
                      <RichText>{item.Description}</RichText>
                    </p>
                    <Button
                      to={item.button_target?.cached_url}
                      className="mt-2 bg-gray-900 text-white my-1 py-2 px-4 rounded-lg shadow-md"
                    >
                      {item.ButtonTitle}
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <Wave
          className={`${blok.lightblue_background ? '' : 'fill-brightgreen'}`}
        />
      </div>
    </SbEditable>
  )
}

export default HeroSlimline
